<template>
  <div id="radio-topic">
    <div class="topic_title">{{listData.order}}.( {{typeText}} ){{listData.questionTitle}}</div>
    <div class="topic_box">
      <p :key="index" class="option" v-for="(item, index) in listData.questionSelect">
        <el-radio :label="item.value" @change="getVal" v-model="radio">{{item.lable}}</el-radio>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'radioTopic',
  props: ['bankData', 'typeText'],
  data () {
    return {
      listData: '',
      radio: ''
    }
  },
  computed: {},

  mounted () {

    let arr = this.bankData.questionSelect

    if (!(arr instanceof Array)) {
      arr = arr.split('###')
      let obj = []
      for (let i = 0; i < arr.length; i++) {
        obj[i] = {}
        obj[i].lable = arr[i]
        obj[i].value = arr[i].substring(0, 1)
      }
         this.bankData.questionSelect = obj
        console.log('sxm')
    }
        this.listData = this.bankData
    if (this.listData.select) {
        this.radio = this.listData.select
    }
  },
  methods: {
    getVal () {
      let obj = {
        examinationItemId: this.listData.examinationItemId,
        select: this.radio
      }
      this.$emit('getChildVal', obj)
    }
  }
}

</script>
<style lang="less" scoped>
.topic_title {
  line-height: 60px;
}
.option {
  line-height: 40px;
}
</style>